import React from 'react';
import { connect } from 'react-redux';
import Dialog from '../../../refresh/molecules/Dialog';
import { getPriceRevealWebData } from '../../../Flags/selectors';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


const mapStateToProps = state => ({
  priceRevealData: getPriceRevealWebData(state.flags)
});

const connector = connect(mapStateToProps);

const PriceRevealDialog = props => {
  const {
    priceRevealData = {},
    visibility,
    hideDialog,
    description,
    clickHandler,
    setVisibility,
    newDesignLuxe
  } = props;
  const {
    bbsDescription = '',
    luxeBBSDescription = '',
    bbsTextButton = '',
    luxeBbsTextButton = '',
    wishlistText = '',
    luxeWishlistText = '',
    hamperImgSrc = {},
    priceImgSrc = {},
    luxePriceImgSrc = {}
  } = priceRevealData;

  return (
    <Dialog
      showDialog={visibility}
      type="modal"
      customClass={newDesignLuxe ? 'luxe-price-reveal-dialog' : ''}
      ariaLabel="Price Reveal"
    >
      <div className="price-reveal-container">
        <div
          onClick={() => {
            hideDialog();
          }}
          className="close-model"
        >
          <span className="ic-close-quickview" />
        </div>
        <div
          className="price-reveal-title"
          contentEditable="true"
          dangerouslySetInnerHTML={{
            __html: `${newDesignLuxe ? luxeBBSDescription : bbsDescription}`
          }}
        />
        <div className="gift-box-container">
          <div className="gift-box-image">
            <img src={replaceWithJioCDN(hamperImgSrc?.image)} alt={hamperImgSrc?.altText ||"Gift Hamper box"} />
          </div>
          <div className="gift-box-button-container">
            <button
              className="gift-box-button"
              onClick={() => {
                setVisibility(false);
                clickHandler(true);
              }}
            >
              {newDesignLuxe ? luxeBbsTextButton : bbsTextButton}
            </button>
          </div>
        </div>
        <div>
          <div className="price-reveal-wishlist">
            <p className="wishlist-text">{newDesignLuxe ? luxeWishlistText : wishlistText}</p>
          </div>
          <div className="price-reveal-description">
            <img
              className="price-reveal-logo"
              src={newDesignLuxe ? replaceWithJioCDN(luxePriceImgSrc?.image) : replaceWithJioCDN(priceImgSrc?.image)}
              alt={newDesignLuxe ? luxePriceImgSrc?.altText : priceImgSrc?.altText ||"price reveal logo"}
            />
            <p className="description-text"> {description} </p>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default connector(PriceRevealDialog);
